module.exports = __webpack_public_path__ + "media/images/payment/amex-013a0538e7f8579433235186b23407b8.svg";